import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import { I18nService } from '@core/i18n-legacy';
import { InterviewTemplateScope, InterviewTemplateSelectors } from '@core/interview-templates-data';
import type { InterviewTemplate } from '@core/interview-templates-types';
import type { SelectGroupedOptions, SelectGroupOption } from '@core/user-interface-legacy';

@Injectable({ providedIn: 'root' })
export class InterviewTemplateSelectService {
  private readonly store = inject(Store);
  private readonly i18n = inject(I18nService);

  public getInterviewTemplates(scope: InterviewTemplateScope) {
    return this.store.select(InterviewTemplateSelectors.entities({ scope })).pipe(filterBoolean);
  }

  public getInterviewTemplatesSelectOptions(scope: InterviewTemplateScope) {
    return this.getInterviewTemplates(scope).pipe(map(templates => this.mapTemplates(templates)));
  }

  private mapTemplates(templates: InterviewTemplate[]): SelectGroupedOptions[] {
    const otherLabel = this.i18n.translate('app.common.other');
    const groups = templates.reduce<Record<string, SelectGroupOption[]>>((acc, template) => {
      const category = template.category || otherLabel;
      (acc[category] ??= []).push({ label: template.name, value: template.id! });
      return acc;
    }, {});

    return Object.entries(groups)
      .map(([title, options]) => ({ title, options }))
      .sort((a, b) => {
        if (a.title === otherLabel) return -1;
        if (b.title === otherLabel) return 1;
        return a.title.localeCompare(b.title);
      })
      .reverse();
  }
}
